// extracted by mini-css-extract-plugin
export default {"main_container":"Statement_main_container__Hue0l"};